import { useState } from '#imports'

import type { Product } from '@backmarket/nuxt-layer-recommendation/models/product'

export function useOutOfStockAlternative() {
  const outOfStockAlternative = useState<Product | null>(
    'pp-out-of-stock-alternative',
    () => null,
  )

  const isOutOfStockAlternativeLoading = useState<boolean>(
    'pp-out-of-stock-alternative-loading',
    () => true,
  )

  function setOutOfStockAlternativeLoading(loading: boolean) {
    isOutOfStockAlternativeLoading.value = loading
  }

  function setOutOfStockAlternative(product: Product | null) {
    outOfStockAlternative.value = product
  }

  function clearOutOfStockAlternative() {
    outOfStockAlternative.value = null
    setOutOfStockAlternativeLoading(true)
  }

  return {
    setOutOfStockAlternativeLoading,
    isOutOfStockAlternativeLoading,
    setOutOfStockAlternative,
    clearOutOfStockAlternative,
    outOfStockAlternative,
  }
}
